/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

'use strict';
module.exports = [function () {
        var moduleConfig = global.ngDroGMap;
        var service = {};

        service.test = function (prm) {
            return "testbar " + prm + " " + moduleConfig.googleApiKey;
        };

        service.getStaticMapUrl = function (centerLat, centerLon, zoom, sizeW, sizeH, maptype, markers, directions) {

            var url = global.ngDroGMap.googleStaticMapApiUrl + "?key=" + moduleConfig.googleApiKey;
            //center
            if (centerLat && centerLon) {
                url = url + "&center=" + centerLat + "," + centerLon;
            }
            //zoom
            if (!zoom) {
                zoom = 11;
            }
            url = url + "&zoom=" + zoom;
            //size (in px)
            if (sizeW && sizeH) {
                url = url + "&size=" + sizeW + "x" + sizeH + "&scale=1";
            }
            //maptype
            if (!maptype) {
                maptype = "roadmap";
            }
            url = url + "&maptype=" + maptype;
            //markers and directions
            //directions
            if (directions) {
                if (!markers) {
                    markers = [];
                }
                //visualizzo solo l'origine e la destinazione del percorso
                if (directions.originLat && directions.originLng) {
                    //origine
                    var marker = {
                        id: directions.idevent
                        , lat: directions.originLat
                        , lon: directions.originLng
                        , icon: directions.icon
                    };


                    markers.push(marker);
                    //destinazione
                    marker = {
                        id: directions.idevent
                        , lat: directions.destinationLat
                        , lon: directions.destinationLng
                        , icon: directions.icon
                    };
                    markers.push(marker);
                }
            }
            ;
            if (markers) {
                var staticMarkerStyle = "";
                var staticMarkerStyleLocation = "";
                markers.forEach(function (marker) {
                    if (marker) {
                        if (staticMarkerStyle === "" && marker.icon) {
                            staticMarkerStyle = "icon:" + global.ngDroGMap.imgUrl + marker.icon + "_small.png|";
                        }
                        ;
                        staticMarkerStyleLocation = staticMarkerStyleLocation + marker.lat + "," + marker.lon + "|";


                    }
                });
                url = url + "&markers=" + staticMarkerStyle + staticMarkerStyleLocation;

            }
            ;
            return url;
        };
        return service;
    }];








//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-gMapModule/services/staticMapService.js
// module id = 329
// module chunks = 0